import React, { useState, useEffect, useMemo } from "react";
import "../../../css/CRUDModal.css";
import ButtonTriangle from "../../../assets/Icons/Button Triangle.png";
import FilterIcon from "../../../assets/Icons/Orange Filter.png";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";
import Dropdown from "../../../components/Dropdown";
import { useForm, Controller } from "react-hook-form";
import { Box } from "@mui/material";
import { axiosPostApi } from "../../../helpers/interceptorServices";
import { apiList } from "../../../helpers/apiList";

const GenerateStickerFilterModal = ({
  show,
  handleClose,
  filterData,
  setFilterData,
  handleReset,
  stickerList = [],
  applyFilters,
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: {
      requestedBy: filterData?.requestedBy || "",
      mobile: filterData?.mobile || "",
    },
    mode: "onChange",
  });

  const watchedValues = watch();

  useEffect(() => {
    if (show) {
      reset({
        requestedBy: filterData?.requestedBy || "",
        mobile: filterData?.mobile || "",
      });
    }
  }, [show, filterData, reset]);

  const [selectedTab, setSelectedTab] = useState("Requested by");
  const [allStickers, setAllStickers] = useState([]);
  const loggedInUserName = sessionStorage.getItem("username");

  useEffect(() => {
    fetchAllStickers();
  }, []);

  const fetchAllStickers = async () => {
    try {
      const response = await axiosPostApi(
        `${apiList.FETCH_GENERATE_STICKER}?pageSize=1000&pageNo=1`,
        { username: loggedInUserName }
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00" &&
        Array.isArray(response?.data?.data)
      ) {
        setAllStickers(response.data.data);
      }
    } catch (err) {
      console.error(
        "Error fetching all stickers for filter dropdowns:",
        err
      );
    }
  };

  // Requested by options (A-Z sorted, unique)
  const combinedRequestedBy = useMemo(() => {
    const nameSet = new Set();

    if (Array.isArray(allStickers)) {
      allStickers.forEach((item) => {
        const name = item?.requestedBy;
        if (name && typeof name === "string" && name.trim()) {
          nameSet.add(name.trim());
        }
      });
    }

    if (Array.isArray(stickerList)) {
      stickerList.forEach((item) => {
        const name = item?.requestedBy;
        if (name && typeof name === "string" && name.trim()) {
          nameSet.add(name.trim());
        }
      });
    }

    const list = Array.from(nameSet);
    list.sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: "base", numeric: true })
    );
    return list;
  }, [allStickers, stickerList]);

  const currentRequestedBy =
    watchedValues?.requestedBy || filterData?.requestedBy || "";

  const requestedByOptions = useMemo(() => {
    const list = combinedRequestedBy.map((name) => ({
      label: name,
      value: name,
    }));

    if (currentRequestedBy) {
      return [
        { label: "✕ Clear Requested by Selection", value: "" },
        ...list,
      ];
    }
    return list;
  }, [combinedRequestedBy, currentRequestedBy]);

  // Mobile No options (numeric sorted, unique)
  const combinedMobileNumbers = useMemo(() => {
    const mobileSet = new Set();

    if (Array.isArray(allStickers)) {
      allStickers.forEach((item) => {
        const mob = item?.mobile;
        if (mob && String(mob).trim()) {
          mobileSet.add(String(mob).trim());
        }
      });
    }

    if (Array.isArray(stickerList)) {
      stickerList.forEach((item) => {
        const mob = item?.mobile;
        if (mob && String(mob).trim()) {
          mobileSet.add(String(mob).trim());
        }
      });
    }

    const list = Array.from(mobileSet);
    list.sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: "base", numeric: true })
    );
    return list;
  }, [allStickers, stickerList]);

  const currentMobile = watchedValues?.mobile || filterData?.mobile || "";

  const mobileDropdownOptions = useMemo(() => {
    const list = combinedMobileNumbers.map((mob) => ({
      label: mob,
      value: mob,
    }));

    if (currentMobile) {
      return [{ label: "✕ Clear Mobile No Selection", value: "" }, ...list];
    }
    return list;
  }, [combinedMobileNumbers, currentMobile]);

  const hasActiveFilter = (tabName) => {
    switch (tabName) {
      case "Requested by":
        return Boolean(
          filterData?.requestedBy && filterData.requestedBy.trim() !== ""
        );
      case "Mobile No":
        return Boolean(filterData?.mobile && filterData.mobile.trim() !== "");
      default:
        return false;
    }
  };

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const onSubmit = (formData) => {
    setFilterData(formData);
    if (applyFilters) {
      applyFilters(formData);
    }
    handleClose();
  };

  const onReset = () => {
    const emptyFilters = {
      requestedBy: "",
      mobile: "",
    };
    reset(emptyFilters);
    setFilterData(emptyFilters);
    handleReset();
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <div className="flex items-center gap-2">
                  <img src={FilterIcon} alt="filter icon" className="w-6 h-6" />
                  <h5 className="modal-title main-title">Filter</h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="close icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleClose}
                />
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {["Requested by", "Mobile No"].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                            style={
                              hasActiveFilter(tab) && selectedTab !== tab
                                ? {
                                    outline: "2px solid #FF6B35",
                                    outlineOffset: "2px",
                                  }
                                : {}
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content !bg-[linear-gradient(to_bottom,#FFE8D4_0%_100%,transparent_25%_100%)]">
                      {/* Requested by Tab */}
                      {selectedTab === "Requested by" && (
                        <Controller
                          name="requestedBy"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Requested by</label>
                              <div className="dateInputWrapper">
                                <Dropdown
                                  placeholder="Select Requested by"
                                  options={requestedByOptions}
                                  value={
                                    field.value ||
                                    watchedValues?.requestedBy ||
                                    filterData?.requestedBy ||
                                    ""
                                  }
                                  labelKey="label"
                                  valueKey="value"
                                  showSearch={true}
                                  selectClassName="!h-[38px] !rounded-[6px]"
                                  onChange={(item) => {
                                    const selectedName =
                                      item && item.value ? item.value : "";
                                    field.onChange(selectedName);
                                    setValue("requestedBy", selectedName);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      requestedBy: selectedName,
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        />
                      )}

                      {/* Mobile No Tab */}
                      {selectedTab === "Mobile No" && (
                        <Controller
                          name="mobile"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Mobile No</label>
                              <div className="dateInputWrapper">
                                <Dropdown
                                  placeholder="Select Mobile No"
                                  options={mobileDropdownOptions}
                                  value={
                                    field.value ||
                                    watchedValues?.mobile ||
                                    filterData?.mobile ||
                                    ""
                                  }
                                  labelKey="label"
                                  valueKey="value"
                                  showSearch={true}
                                  selectClassName="!h-[38px] !rounded-[6px]"
                                  onChange={(item) => {
                                    const selectedMobile =
                                      item && item.value ? item.value : "";
                                    field.onChange(selectedMobile);
                                    setValue("mobile", selectedMobile);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      mobile: selectedMobile,
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back w-[133px] !rounded-lg"
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="submit"
                      className="btn btn-submit w-[133px] !rounded-lg"
                      disabled={isSubmitting}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GenerateStickerFilterModal;
